export const QUERY_KEY = 'DASHBOARD_RECENTLY_VIEWED' as const;
